// extracted by mini-css-extract-plugin
module.exports = {"service_detail":"each_service_detail_service_detail__tl91r"};